import { MyTableComponent, Input } from "components"
import { useState, useEffect } from "react"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"

export const CounterValueTable = ({ _selectedDeviceData }: any) => {
 const [selectedData, setSelectedData] = useState<any[]>([])
 const [allData, setAllData] = useState<any[]>([])

 const columns = [
  {
   Header: "device",

   Cell: ({ row }: any) => {
    return <div>{row.original.common_information.device_name}</div>
   },
  },
  {
   Header: "detectors",
   Cell: ({ row }: any) => {
    return row.original?.oepnv_data_elements?.map((single: any) =>
     single.detector_list.map((list: any, index: number) => (
      <div key={index}>{list?.detector_name}</div>
     )),
    )
   },
  },
  {
   Header: "counter value",
   Cell: ({ row }: any) => {
    return row.original?.oepnv_data_elements?.map((single: any) =>
     single.detector_list.map((list: any, index: number) => (
      <div key={index}>{list?.counter_value}</div>
     )),
    )
   },
  },
  {
   Header: "occupancy value",
   Cell: ({ row }: any) => {
    return row.original?.oepnv_data_elements?.map((single: any) =>
     single.detector_list.map((list: any, index: number) => (
      <div key={index}>{list?.occupancy_values}</div>
     )),
    )
   },
  },
  {
   Header: "interval",
   Cell: ({ row }: any) => {
    return row.original?.oepnv_data_elements?.map((single: any) =>
     single.interval.map((interval: any, index: number) => <div key={index}>{interval}</div>),
    )
   },
  },
  {
   Header: "packets",
   Cell: ({ row }: any) => {
    return row.original?.oepnv_data_elements?.map((single: any, index: number) => (
     <div key={index}>{single.packets}</div>
    ))
   },
  },
 ]

 useEffect(() => {
  if (_selectedDeviceData) {
   setSelectedData(_selectedDeviceData)
   setAllData(_selectedDeviceData)
  }
  // eslint-disable-next-line
 }, [_selectedDeviceData])
 const searchHandler = (keyword: string) => {
    if (keyword !== "") {
     const filterData: any = allData?.filter(
      (item) =>
      item?.common_information?.device_name?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
     )
     setSelectedData([...filterData])
    } else {
     setSelectedData(allData)
    }
   }

 return (
  <div className="w-full mx-auto relative lg:h-screen">
   <div className="py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">Zählwertdaten</h1>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">Zählwertdaten</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">Category</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px] flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder="Search"
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={_selectedDeviceData ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
